export default __webpack_public_path__ + "static/icon-circle-3081fc3fdc05eeb0d3ecc8d3f6188f17.png";